import { render, staticRenderFns } from "./AddressListRight.vue?vue&type=template&id=2334cfa5&scoped=true&"
import script from "./AddressListRight.vue?vue&type=script&lang=js&"
export * from "./AddressListRight.vue?vue&type=script&lang=js&"
import style0 from "./AddressListRight.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AddressListRight.vue?vue&type=style&index=1&id=2334cfa5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2334cfa5",
  null
  
)

export default component.exports